import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionHeader } from '../../components/SectionHeader.js';

export const Faq: React.FC = () => {
  const faqs = [
    {
      question: 'Google Vault と一緒に使うことはできますか？',
      answer:
        'はい、併用を強くおすすめしています。普段のメール検索にはGoogle Vaultを使い、最悪の事態（管理者の乗っ取り、ランサムウェア被害、退職者のアカウント解約後のデータ長期保管）に備えてARAYAで隔離保管する「二重の備え」が可能です。',
    },
    {
      question: '社員のパソコンに何かソフトをインストールする必要がありますか？',
      answer:
        'いいえ、社員のパソコンへのソフト導入は一切不要です。Google Workspaceの管理画面から一度連携を設定するだけで、すべてクラウド上で自動的にバックアップが行われます。',
    },
    {
      question: '保存したデータは誰が管理することになりますか？',
      answer:
        'お客様企業専用のGoogle Cloud環境に安全に保管されます。暗号化の鍵もお客様企業専用のものを使用するため、当社を含めた外部の人間がデータを閲覧することは技術的に一切できません。',
    },
    {
      question: '退職した社員のデータを取り出したい時はどうすればいいですか？',
      answer:
        '専用の管理画面から、社員名、日付、サービス（メール・ドライブ・カレンダー）を指定して、必要なファイルだけを即座にパソコンへダウンロード・復元できます。監査提出用の出力も可能です。',
    },
    {
      question: '申し込みから利用開始までどれくらいかかりますか？ お試しはできますか？',
      answer:
        '最短1営業日で導入可能です。まずは一部の部署やテスト用アカウントだけで試せる「無料デモ・PoC」をご用意していますので、実際の使い勝手やデータ復元をお気軽にご確認いただけます。',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-20 md:py-28 relative">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          tag="FAQ"
          tagVariant="indigo"
          title="よくあるご質問"
          description="導入要件、運用体制、セキュリティ仕様に関する主要な疑問にお答えします。"
        />

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="rounded-2xl border border-slate-200/90 bg-white shadow-xs overflow-hidden transition-all hover:border-slate-300"
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  className="w-full py-5 px-6 sm:px-8 text-left flex items-center justify-between gap-4 focus:outline-none"
                  aria-expanded={isOpen}
                >
                  <span className="font-bold text-base text-slate-800 flex items-center gap-3">
                    <span className="text-emerald-600 font-mono text-sm font-extrabold">Q.</span>
                    {faq.question}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-slate-400 shrink-0 transition-transform duration-200 ${
                      isOpen ? 'rotate-180 text-emerald-600' : ''
                    }`}
                  />
                </button>

                {isOpen && (
                  <div className="px-6 sm:px-8 pb-6 pt-2 text-sm text-slate-600 leading-relaxed border-t border-slate-100 bg-slate-50/50">
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
